import styled from "styled-components";

export const SelectInputComponentStyle = styled.div`
   width: 100%;

   .react-select__control {
      background-color: #FAFAFA;
      border: 1px solid #EDEDED;
      border-radius: 5px;
      font-size: 1.4rem !important,
   }
`;
